<form [formGroup]="form">
    <div class="row">
        <div class="form col-md-12">
            <h2>Data de {{dado.tipo}} do contrato:</h2>
            <mat-form-field appearance="fill">
                <mat-label>Escolha uma data</mat-label>
                <input matInput [matDatepicker]="picker" formControlName="data">
                <mat-hint>DD/MM/YYYY</mat-hint>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
        </div>
        <div class="form col-md-12" *ngIf="dado.tipo=='renovação'" style="margin-top: 2rem;">
            <h2>Data de vencimento do próximo contrato:</h2>
            <mat-form-field appearance="fill">
                <mat-label>Escolha uma data</mat-label>
                <input matInput [matDatepicker]="picker1" formControlName="dataVencimento">
                <mat-hint>DD/MM/YYYY</mat-hint>
                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                <mat-datepicker #picker1></mat-datepicker>
            </mat-form-field>
        </div>
    </div>
    <div id="buttons">
        <button class="btn-sucesso btn btn-lg btn-success" type="submit" (click)="confirmar()">Confirmar</button>
        <button (click)="cancel()" class="btn-cancelar btn btn-lg btn-danger" type="btn">Cancelar</button>
    </div>
</form>